import styled from "styled-components/macro";

export default styled.h2`
    background-color: #D3DEE6;
    padding: 15px 20px;
`;
